// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"db23be3c","57":"b9a42028","124":"8c6366b8","353":"e5ab4e22","449":"29a293b7","453":"87e45203","660":"dff304d2","697":"31498dcd","712":"a7586ba3","819":"b1101483"}[chunkId] + ".chunk.js";
};